import { Badge } from "antd";

const ConversationBadge = ({ total }) => {
  return <Badge count={total} />;
};

export default ConversationBadge;
